import React from "react";
import AppRouter from "./utils/AppRouter";
import { withCookies } from "react-cookie";
import AuthProvider from "./Context/AuthContext";
import { NavProvider } from "./Context/NavContext";
import OrganisationContextProvider from "./Context/OrganisationContext";
import { ModalProvider } from "./Context/ModalContext";
import SVGSprite from "./components/SVGSprite";
import { Helmet } from "react-helmet";
import Favicon from "./assets/icons/favicon.ico";
import { Cookies } from "react-cookie";
import { OnboardingProvider } from "./Context/OnboardingContext";
import { TeamsProvider } from "./Context/TeamsContext";
import ConsumerPortalSelectProvider from "./Context/ConsumerPortalSelectContext";
import { CustomerSyncProvider } from "./Context/CustomerSyncContext";
import CustomerSyncPolling from "./Polling/CustomerSyncPolling";
import "./App.css";

const App = () => {
  const cookies = new Cookies();
  const userFromCookies =
    cookies.get("authUser", { path: "/", secure: true }) || {};
  // const root = ReactDOM.createRoot(document.getElementById("root"));
  return (
    <>
      <NavProvider>
        <OrganisationContextProvider>
          <AuthProvider>
            <CustomerSyncProvider>
              <ModalProvider>
                <TeamsProvider>
                  <ConsumerPortalSelectProvider>
                    <Helmet>
                      <link rel='shortcut icon' href={Favicon} />
                    </Helmet>
                    <SVGSprite />
                    <CustomerSyncPolling />
                    <OnboardingProvider user={userFromCookies}>
                      <AppRouter />
                    </OnboardingProvider>
                  </ConsumerPortalSelectProvider>
                </TeamsProvider>
              </ModalProvider>
            </CustomerSyncProvider>
          </AuthProvider>
        </OrganisationContextProvider>
      </NavProvider>
    </>
  );
};

export default withCookies(App);
